// function to get the offset of an element
export function getOffset(element) {
    let bound = element.getBoundingClientRect()
    let html = document.documentElement
    return {
        top: bound.top + window.scrollY - html.clientTop,
        left: bound.left + window.scrollX - html.clientLeft,
        width: bound.width,
        height: bound.height,
    }
}
